import { useEffect, useRef } from 'react';

export function useDebouncedCommit({ value, delay = 400, onCommit }) {
  const timeoutRef = useRef(null);
  const lastValueRef = useRef(value);

  useEffect(() => {
    if (value === lastValueRef.current) return;

    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      lastValueRef.current = value;
      onCommit(value);
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, [value, delay, onCommit]);

  const flush = () => {
    clearTimeout(timeoutRef.current);
    if (value !== lastValueRef.current) {
      lastValueRef.current = value;
      onCommit(value);
    }
  };

  return { flush };
}
